import { makeStyles } from '@mui/styles';
import ClusterColumnChart from 'apollo-react/components/ClusterColumnChart';
import Tooltip from 'apollo-react/components/Tooltip';
import Typography from 'apollo-react/components/Typography';
import Info from 'apollo-react-icons/Info';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import ReactResizeDetector from 'react-resize-detector';

import { useTranslation } from '../../../custom-hooks/useTranslation';
import { getUITA, isTrue } from '../../../utils/commonUtils';
import Accordion from '../../components/Accordion';
import {
  DEFAULT_CLUSTER_COLUMN_CHART_DATA,
  DEFAULT_CLUSTER_COLUMN_CHART_DATA_MESSAGE,
} from '../../constants/editor.constants';

const useStyles = makeStyles({
  containerWithDefaultData: {
    display: 'flex',
  },
  controlWithDefaultData: {
    flexGrow: 1,
  },
});

const SSEditorClusterColumnChart = ({
  title,
  header,
  evaluatedData,
  width,
  height,
  yTicks,
  suffix,
}) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const [remount, setRemount] = useState(false);

  useEffect(() => {
    // ClusterColumnChart is not responsive
    // we need to remount it every time its size is changed
    remount && setRemount(false);
  }, [remount]);

  useEffect(() => {
    setRemount(true);
  }, [width, height]);

  return (
    <>
      <div className={!evaluatedData ? classes.containerWithDefaultData : null}>
        <div
          className={!evaluatedData ? classes.controlWithDefaultData : null}
          ui-ta={getUITA('FormPart', 'SSClusterColumnChart')}
        >
          <Accordion
            isCollapsed={false}
            showHeader={isTrue(header) && !_.isNil(title)}
            title={title}
          >
            {!remount && (
              <ClusterColumnChart
                data={evaluatedData ?? DEFAULT_CLUSTER_COLUMN_CHART_DATA}
                width={width}
                height={height}
                yTicks={yTicks}
                suffix={suffix}
              />
            )}
          </Accordion>
        </div>
        {!evaluatedData && (
          <Tooltip
            extraLabels={[
              {
                title: (
                  <Typography>
                    {translateString(DEFAULT_CLUSTER_COLUMN_CHART_DATA_MESSAGE)}
                  </Typography>
                ),
                subtitle: '',
              },
            ]}
            placement="bottom"
            variant="light"
          >
            <Info color="primary" />
          </Tooltip>
        )}
      </div>
      <ReactResizeDetector handleWidth onResize={() => setRemount(true)} />
    </>
  );
};

export default SSEditorClusterColumnChart;
